$(function($) {
  
  var redirect_ca = $.cookie('redirect_ca');
  
  var redirect = (function () {

      var sites = {
          "gb":true,
          "ca":true,
          "us":true
      };

     
      var onSuccess = function (geoipResponse) {
      	$('#redirect-bar .text .country').text(geoipResponse.country.names.en);    
          if (!geoipResponse.country.iso_code) { 
              return;
          }


          var code = geoipResponse.country.iso_code.toLowerCase();
          if ( sites[code] ) {   
            if((code == "us") && (redirect_ca != 'no'))  {
              $('#store-link').attr('href','https://oqspecs.com' ,'_self');
                 $('.store-link').text('Take me to oqspecs.com'); 
                           setTimeout(function () {
                 $('#redirect-bar').slideDown('slow');  
               }, 300);
  
             }
            else if(code == "gb" && (redirect_ca != 'no')) {
              $('#store-link').attr('href','https://olliequinn.co.uk' ,'_self');
                 $('.store-link').text('Take me to olliequinn.co.uk'); 
                           setTimeout(function () {
                 $('#redirect-bar').slideDown('slow');  
               }, 300);
  
             }    }
      };


      var onError = function (error) {

        console.log("REDIRECT ERROR");
        console.log(error);
      };

      return function () {
          geoip2.country( onSuccess, onError );
      };
  }()); 
  
   redirect();

    
  if (redirect_ca == 'no') {
    return false;
  }      
    
  // onclick close redirect bar
  $('.redirect-btn.no').click(function(e) {
    e.preventDefault();
    $('#redirect-bar').slideUp('slow'); 


    $.cookie('redirect_ca', 'no', {expires: 7, path: '/' });
  });
     
});